import * as React from "react";
import PropTypes from "prop-types";
import Slider from "../Slider";
import { Item, Divider } from "../ItemList";
import { calcPreviewColor, calcPreviewColorBulb } from "./utils";

const PREVIEW_SIZE = 7.5;
const SLIDER_MARGIN = 12;
const styles = {
  label: {
    width: "4em",
  },
  slider: {
    margin: `${SLIDER_MARGIN}px 0`,
  },
};

export default class ColorPicker extends React.Component {
  static propTypes = {
    warm: PropTypes.number,
    cool: PropTypes.number,
    red: PropTypes.number,
    green: PropTypes.number,
    blue: PropTypes.number,
    bulb: PropTypes.bool,
    showRGB: PropTypes.bool,
    showWarmCool: PropTypes.bool,
    isHorizontal: PropTypes.bool,
    onDragStart: PropTypes.func,
    onDragEnd: PropTypes.func,
  };

  static defaultProps = {
    warm: 0,
    cool: 0,
    red: 0,
    green: 0,
    blue: 0,
    bulb: false,
    showRGB: false,
    showWarmCool: false,
    isHorizontal: false,
  };

  constructor(props) {
    super(props);
    const { warm, cool, red, green, blue } = this.props;
    const previewColor = this._calcPreviewColor({
      warm,
      cool,
      red,
      green,
      blue,
    });

    this.state = { warm, cool, red, green, blue, previewColor };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let { warm, cool, red, green, blue } = nextProps;
    [warm, cool, red, green, blue] = [warm, cool, red, green, blue].map(
      Math.round
    );
    const previewColor = this._calcPreviewColor({
      warm,
      cool,
      red,
      green,
      blue,
    });
    this.setState({ warm, cool, red, green, blue, previewColor });
  }

  _calcPreviewColor = (colors) => {
    if (this.props.bulb) {
      return calcPreviewColorBulb(colors);
    } else {
      return calcPreviewColor(colors);
    }
  };

  _handleDragEnd = (color, value, aborted) => {
    let newState;
    if (aborted) {
      newState = this.state;
    } else {
      let newColors;
      switch (color) {
        case "warm": {
          newColors = { warm: value, cool: 0, red: 0, green: 0, blue: 0 };
          break;
        }
        case "cool": {
          newColors = { warm: 0, cool: value, red: 0, green: 0, blue: 0 };
          break;
        }
        case "red":
        case "green":
        case "blue": {
          newColors = { warm: 0, cool: 0, [color]: value };
          break;
        }
        default: {
          throw new Error(`Can't handle unknown color: ${color}`);
        }
      }
      newState = {
        ...this.state,
        ...newColors,
      };
      this.setState({
        ...newState,
        previewColor: this._calcPreviewColor(newState),
      });
    }

    if (this.props.onDragEnd) {
      this.props.onDragEnd(newState);
    }
  };

  _getSlidersForColors = (colors) => {
    return colors.map((color) => {
      const capitalizedColor = color[0].toUpperCase() + color.slice(1);
      const label = <div style={styles.label}>{capitalizedColor}</div>;
      return (
        <Item
          key={color}
          id={color}
          label={label}
          childWrapperStyle={{ flex: "1 1 100%" }}
        >
          <Slider
            min={0}
            max={255}
            value={this.state[color]}
            sliderStyle={styles.slider}
            onDragStart={this.props.onDragStart}
            onDragEnd={(value, aborted) => {
              this._handleDragEnd(color, value, aborted);
            }}
          />
        </Item>
      );
    });
  };

  render() {
    const { bulb, isHorizontal, showRGB, showWarmCool } = this.props;
    const { previewColor } = this.state;

    const dynamicStyles = {
      preview: {
        boxSizing: "border-box",
        height: `${PREVIEW_SIZE}em`,
        width: `${PREVIEW_SIZE}em`,
        margin: "auto",
        borderRadius: "50%",
        backgroundColor: previewColor,
        boxShadow: bulb ? "inset 0 0 2em #FFE" : "",
        border: "solid lightgray 1px",
      },
      previewDiv: {
        width: `${PREVIEW_SIZE + 1}em`,
        margin: "0 auto",
        ...(isHorizontal && {
          float: "left",
          position: "absolute",
          top: "50%",
          marginTop: `-${PREVIEW_SIZE / 2}em`,
        }),
      },
      sliderDiv: isHorizontal ? { marginLeft: `${PREVIEW_SIZE + 1}em` } : {},
    };

    return (
      <div data-component-name="ColorPicker" style={{ position: "relative" }}>
        <div style={dynamicStyles.previewDiv} data-component-section="Preview">
          <div style={dynamicStyles.preview} />
        </div>
        <div style={dynamicStyles.sliderDiv} data-component-section="Sliders">
          {showWarmCool ? this._getSlidersForColors(["warm", "cool"]) : null}
          {showRGB && showWarmCool ? <Divider /> : null}
          {showRGB ? this._getSlidersForColors(["red", "green", "blue"]) : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/ColorPicker/index.jsx